/**
 * PlayStoreButton — Google Play download button.
 *
 * Presentational only: give it a resolved `href` (build one with
 * `generatePlayStoreLink` / `generateAppStoreLinks` from `@butter/library/shared`).
 *
 * @module butterUI/domains/app/PlayStoreButton
 */

import { GooglePlayIcon } from '#icons';
import { StoreLinkButton } from './StoreLinkButton';

export interface PlayStoreButtonProps {
  /** Google Play URL. */
  href: string;
  className?: string;
}

export function PlayStoreButton({ href, className }: PlayStoreButtonProps) {
  return (
    <StoreLinkButton
      href={href}
      className={className}
      icon={<GooglePlayIcon className="h-6 w-6" />}
      topLine="GET IT ON"
      bottomLine="Google Play"
    />
  );
}
